import RegisterSummary from './RegisterSummary';

export default RegisterSummary;
